module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lltxc"))).then(() => parcelRequire('ikE14'));